/* EMOTION LIBRARY: 本棚から一巻を手に取る／物語ページの読み方切替 */
(() => {
  "use strict";
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v === null ? d : JSON.parse(v); } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} }
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]));

  /* ---------- 本棚 ---------- */
  const root = document.querySelector("[data-el-library]");
  if (root) {
    const D = JSON.parse(document.getElementById("el-data").textContent);
    const A = D.assets;
    const yen = (n) => "¥" + n.toLocaleString("ja-JP");
    const dlg = root.querySelector(".el-dlg");
    const $ = (s) => dlg.querySelector(s);
    const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    let current = null;

    const open = (no) => {
      const v = D.volumes.find((x) => x.no === no); if (!v) return;
      current = v;
      const s = D.styles[v.style], n = D.nights[v.night];
      dlg.style.setProperty("--band", `var(--s-${v.style})`);
      const tag = `<span class="el-tag"><img class="paper" src="${A.tag}" alt="" width="168" height="560"><img class="qr" src="${A.qr.replace("NN", no)}" alt="VOL.${no}の物語ページへのQRコード" width="33" height="33"><span class="cap">栞の先に、物語</span></span>`;
      // 瓶の複製の中に栞を入れ、首から垂らす
      $(".stage").innerHTML =
        root.querySelector(`#el-vol-${no}`).outerHTML.replace(/<button/, '<div aria-hidden="true"').replace(/id="[^"]*"/, "").replace(/<\/button>$/, tag + "</div>");
      // 何の一本かを先に、ラベルで言う（巻・気分・味・容量）
      $(".meta").innerHTML = `<span class="latin">VOL. ${v.no}</span><span>気分：${esc(n.ja)}</span><span><i></i>${esc(s.name)} ${s.abv}</span><span>330ml</span>`;
      $("h2").innerHTML = `${esc(v.line)}<span class="latin">${esc(v.en)}</span>`;
      $(".syn p").textContent = v.synopsis || "";
      const first = (v.opening[0] || "").replace(/。.*$/s, "。");
      $("dl").innerHTML =
        `<dt>こんなときに</dt><dd>${esc(n.lead)}に。</dd>` +
        `<dt>ビール</dt><dd>${esc(s.name)}（${esc(s.ja)}）。${esc(s.note)}。</dd>` +
        `<dt>物語</dt><dd>約${v.minutes}分・${v.chars.toLocaleString("ja-JP")}字。最後に、合う音（${esc(v.music)}）と、つまむもの（${esc(v.food)}）を添えています。</dd>` +
        `<dt>書き出し</dt><dd class="first">${esc(first)}</dd>`;
      $(".el-price").innerHTML = `${yen(D.price)}<small>予定価格・税込</small>`;
      $(".read").href = `/pages/emotion-library-${v.no}`;
      $(".read").textContent = `物語を読む（約${v.minutes}分）`;
      dlg.showModal();
    };

    // B版は参考の作りに合わせ、選ぶと画面ごと白くフェードしてから一巻が浮かぶ（遷移も同じ幕で隠す）
    const fade = root.querySelector(".el-fade");
    const FADE = 1000; // 参考（cocochi.design）と同じ 1秒で白くし、少し置いてから窓を出す
    const veil = (on) => fade && fade.classList.toggle("on", on);
    const shut = () => {
      if (!fade) return dlg.close();
      dlg.classList.add("is-closing");
      setTimeout(() => { dlg.classList.remove("is-closing"); dlg.close(); }, 300);
    };

    root.querySelector(".el-case").addEventListener("click", (e) => {
      const b = e.target.closest(".el-vol, .el-face, .el-spine, [data-take]"); if (!b) return;
      // 幕は「動きを減らす」設定でも出す（動くのではなく色が変わるだけなので）。浮く動きだけ省く
      if (fade) {
        if (!reduce) b.dataset.out = "true"; // 選んだものが少し浮いてから幕が下りる
        setTimeout(() => veil(true), 120);
        setTimeout(() => { b.removeAttribute("data-out"); open(b.dataset.no); requestAnimationFrame(() => veil(false)); }, 120 + FADE + 150);
        return;
      }
      if (reduce) return open(b.dataset.no);
      b.dataset.out = "true";
      setTimeout(() => { b.removeAttribute("data-out"); open(b.dataset.no); }, 260);
    });
    dlg.addEventListener("click", (e) => { if (e.target === dlg || e.target.closest("[data-close]")) shut(); });
    if (fade) {
      // 物語へ進むときは窓を閉じ、幕を下ろしてから移る
      dlg.querySelector(".read").addEventListener("click", (e) => {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        const href = e.currentTarget.href;
        dlg.close(); veil(true);
        setTimeout(() => { location.href = href; }, FADE);
      });
      addEventListener("pageshow", () => veil(false)); // 戻るで戻ったときに幕を上げる
    }
    dlg.addEventListener("close", () => { if (current) root.querySelector(`#el-vol-${current.no}`)?.focus(); });

    const pick = root.querySelector(".el-pick"); // B版（壁の本棚）でも同じ部品名で使う
    pick.addEventListener("click", (e) => {
      const b = e.target.closest("button"); if (!b) return;
      pick.querySelectorAll("button").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
      // 札は味（data-style）でも気分（data-night）でも絞れる
      const key = "night" in b.dataset ? "night" : "style", val = b.dataset[key];
      root.querySelectorAll(".el-case [data-no]").forEach((el) => {
        if (val === "all") el.removeAttribute("data-match"); else el.dataset.match = String(el.dataset[key] === val);
      });
    });

    const m = location.hash.match(/^#vol-(\d{2})$/);
    if (m) open(m[1]);
  }

  /* ---------- 物語ページ ---------- */
  // 縦書きのときは本文を画面に留め、縦のスクロール量を横の送りに換える（右から左へ読み進む）
  const page = document.querySelector("[data-el-story]");
  if (page) {
    const body = page.querySelector(".el-body"), tate = page.querySelector("#el-tate");
    const scroller = page.querySelector(".el-scroller"), stage = page.querySelector(".el-stage"), track = page.querySelector(".el-track");
    const pct = page.querySelector(".el-prog b");
    let dist = 0, ticking = false;

    const frame = () => {
      ticking = false;
      if (page.dataset.tate !== "true") return;
      const run = scroller.offsetHeight - stage.offsetHeight;
      const top = scroller.getBoundingClientRect().top - parseFloat(getComputedStyle(stage).top);
      const p = run > 0 ? Math.min(1, Math.max(0, -top / run)) : 0;
      track.style.transform = `translate3d(${(p * dist).toFixed(1)}px,0,0)`;
      stage.style.setProperty("--p", p.toFixed(4));
      pct.textContent = Math.round(p * 100) + "%";
      page.dataset.moved = String(p > 0.01);
    };
    const tick = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
    const layout = () => {
      if (page.dataset.tate !== "true") { scroller.style.height = ""; track.style.transform = ""; return; }
      dist = Math.max(0, track.scrollWidth - stage.clientWidth);
      scroller.style.height = stage.offsetHeight + dist + "px"; // 横に送る距離ぶん縦に伸ばす
      frame();
    };

    const applyTate = (on) => { page.dataset.tate = String(on); tate.setAttribute("aria-pressed", String(on)); layout(); };
    const applyFs = (fs) => {
      body.style.setProperty("--fs", fs);
      page.querySelectorAll("[data-fs]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.fs === fs)));
      layout();
    };
    applyTate(store.get("el:tate2", true));
    applyFs(store.get("el:fs", "17px"));
    tate.addEventListener("click", () => {
      const on = page.dataset.tate !== "true"; applyTate(on); store.set("el:tate2", on);
      scroller.scrollIntoView({ block: "start" });
    });
    page.querySelectorAll("[data-fs]").forEach((b) => b.addEventListener("click", () => { applyFs(b.dataset.fs); store.set("el:fs", b.dataset.fs); }));
    addEventListener("scroll", tick, { passive: true });
    addEventListener("resize", layout);
    document.fonts?.ready.then(layout);

    const btn = page.querySelector(".el-copy"), st = page.querySelector(".el-copy-state"), tag = page.querySelector(".el-tagline");
    btn.addEventListener("click", () => {
      const fallback = () => { const r = document.createRange(); r.selectNodeContents(tag); const s = getSelection(); s.removeAllRanges(); s.addRange(r); st.textContent = "選択しました。長押しでコピーできます。"; };
      try { navigator.clipboard.writeText(tag.textContent).then(() => { st.textContent = "コピーしました。"; }, fallback); } catch { fallback(); }
    });
  }
})();
